import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ComboBoxComponent} from './combo-box.component';
import {ListGroupModule} from '../list-group/list-group.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {InputModule} from '../input/input.module';

@NgModule({
  declarations: [
    ComboBoxComponent
  ],
  imports: [
    CommonModule,
    ListGroupModule,
    FormsModule,
    NgbDropdownModule,
    InputModule
  ],
  exports: [
    ComboBoxComponent
  ]
})
export class ComboBoxModule {
}
